import {
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IPagination } from "../../data/AppInterface";
import {
  TBitValue,
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  ACTIVE_INACTIVE_ROLE,
  DELETE_ROLE,
  GET_ALL_ROLES,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
  toastSuccess,
} from "../../utils/AppFunctions";

export interface IRoles {
  id: string;
  role_name: string;
  is_active: TBitValue;
  is_deleted: TBitValue;
  claim_count: string;
}

export function getRolesFields<T>(
  actionComponent: (item: T) => JSX.Element,
  handleRolesStatus: (item: T) => void,
  handleDisabledRolesStatus: (item: T) => boolean,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("role_name"),
      key: "role_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("claim_count"),
      key: "claim_count",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },

    {
      name: t("status"),
      key: "is_active",
      sort: false,
      type: TABLE_FIELD_TYPE.switch,
      align: TABLE_FIELD_ALIGN.center,
      checkedValue: "1",
      flex: "col-span-2",
      handleCheck: handleRolesStatus,
      disabled: handleDisabledRolesStatus,
    },
    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
      component: actionComponent,
    },
  ];
}

export const getAllRoles = async (
  setRole: TReactSetState<IRoles[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string
) => {
  try {
    const roles = await GET_ALL_ROLES(pagination, search);
    if (roles && roles.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setRole(roles.data.item);
      setPagination(roles.data.pagination);
    } else {
      setRole([]);
      sweetAlertError({
        message: roles.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllRoles");
  }
};

export const deleteRole = async (id: string) => {
  try {
    const deleteData = await DELETE_ROLE(id);
    if (deleteData && deleteData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deleteData.message });
      return true;
    } else {
      sweetAlertError({
        message: deleteData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteRole");
    return false;
  }
};

export const activeInactiveRole = async (id: string, values: TBitValue) => {
  try {
    const activeInactiveData = await ACTIVE_INACTIVE_ROLE(id, {
      is_active: values,
    });
    if (
      activeInactiveData &&
      activeInactiveData.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      toastSuccess(activeInactiveData.message);
      return true;
    } else {
      sweetAlertError({
        message: activeInactiveData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "activeInactiveRole");
    return false;
  }
};
